<template>
    <div class="contenedor_empresas">

        <div class="caja_seleccion">
            <b-container fluid="">
                <b-row>
                    <div class="col-sm-12 mt-3">
                        <h3>
                            Empresas
                        </h3>
                    </div>
                    <div class="col-sm-12 mt-3">
                        <label for="" class="form-label">Seleccionar empresa</label>
                        <select class="form-control form-control-sm" v-model="select_empresa">
                            <option value="">Seleccionar</option>
                            <option v-for="(item, index) in datos_usuario.empresas" :key="index"
                                :value="item.codigo_empresa">{{ item.nombre_empresa }}</option>
                        </select>
                    </div>
                    <div class="col-sm-12 mt-3">
                        <button type="button" class="btn btn-sm btn-outline-dark btn-block"
                            @click="seleccionar_empresa">Seleccionar</button>
                    </div>
                    <div class="col-sm-12 mt-5">
                        <div class="contenedor_boton_cerrar_sesion">
                            <div class="cuadro_cerrar_sesion" @click="cerrar_sesion">
                                <i class="fas fa-power-off"></i>
                            </div>

                        </div>

                    </div>

                </b-row>
            </b-container>
        </div>
        <Cargando v-if="set_cargando" titulo="Cargando datos..." />
    </div>
</template>

<script>
    import { minix } from '@/components/functions/alertas';
    import { mapActions, mapMutations, mapState } from 'vuex';
    import Cargando from '../components/Loading/Cargando.vue'

    export default {
        name: 'Empresas',
        computed: {
            ...mapState(['datos_usuario'])
        },
        components: {
            Cargando
        },
        data() {
            return {
                select_empresa: '',
                set_cargando: false
            }
        },
        methods: {
            seleccionar_empresa(id) {
                if (this.select_empresa == '') {
                    minix({ icon: 'info', mensaje: 'Seleccione una empresa', tiempo: 3000 })
                } else {
                    this.set_id_empresa_seleccionada(this.select_empresa)
                    const nombre_empresa = this.datos_usuario.empresas.find(item => item.codigo_empresa === this.select_empresa).nombre_empresa;
                    this.set_nombre_empresa_seleccionada(nombre_empresa)

                    this.set_cargando = true
                    setTimeout(() => {
                        if (this.datos_usuario.nivel == 0) {
                            this.$router.push('escritorio')
                            this.set_cargando = false
                        } else if (this.datos_usuario.nivel == 1) {
                            this.$router.push('facturador')
                            this.set_cargando = false
                        }
                    }, 1000);

                }
            },
            async validardor_facturador() {
                if (this.datos_usuario.nivel == 1) {
                    await this.set_id_empresa_seleccionada(this.datos_usuario.empresa)
                    await this.$router.push('facturador')
                }
            },
            ...mapActions(['obtener_datos_usuario', 'cerrar_sesion']),
            ...mapMutations(['set_id_empresa_seleccionada', 'set_nombre_empresa_seleccionada'])
        },
        async mounted() {
            await this.obtener_datos_usuario()
            await this.validardor_facturador()
        }
    }
</script>

<style>
    .contenedor_empresas {
        width: 100%;
        height: 100vh;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .caja_seleccion {}

    .cuadro_cerrar_sesion {
        border: 1px solid #e9e9e9;
        width: 50px;
        height: 50px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        font-size: 25px;
        border-radius: 50%;
        transition: .4s;
    }

    .cuadro_cerrar_sesion:hover {
        background: #de1717;
        color: white;
    }

    .cuadro_cerrar_sesion:active {
        scale: 0.9;
    }

    .contenedor_boton_cerrar_sesion {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }

</style>